<div class="flex flex-col gap-2 w-[400px] bg-gray-100">
  <div *ngFor="let inAppNotification of inAppNotifications" class="p-2 border-b flex flex-col gap-2 cursor-pointer"
       (click)="openNotification(inAppNotification)">
    <div class="flex gap-3 justify-between flex-wrap">
      <span class="text-gray-500 font-bold">{{ inAppNotification?.title }}</span>
      <span class="text-gray-500 text-sm italic">{{ inAppNotification?.createdDate | date: 'mediumDate' }}</span>
    </div>
    <span class="text-gray-500 text-sm">{{ inAppNotification?.message }}</span>
  </div>

  <div class="flex justify-between mb-2 font-bold">
    <div>
      <button class="px-2 py-1 text-xs" (click)="$event.stopPropagation(); loadData(pageObject?.previousPageNumber)"
              *ngIf="pageObject?.hasPreviousPage">Prev
      </button>
    </div>
    <button (click)="$event.stopPropagation(); loadData(pageObject?.nextPageNumber)" class="px-2 py-1 text-xs"
            *ngIf="pageObject?.hasNextPage">Next
    </button>
  </div>

</div>
